/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeTabs } from '@base/react';
import * as React from 'react';

import { ChatParameterization } from '../ChatParameterization/chat-parameterization';
import { CalibrateNotes } from '../calibrate-notes/calibrate-notes';
import { Container, Content, ContentWrapper } from './settings-styled';

export const Settings = () => {
  const [onTabIndex, setOnTabIndex] = React.useState(0);

  return (
    <Container>
      <ContentWrapper>
        <Content>
          <BaSeTabs
            activatedTabIndex={onTabIndex}
            activeColor="#005eb8"
            inactiveColor="#617385"
            onActivatedTabIndex={setOnTabIndex}
            tabGap={24}
            tabs={[
              {
                content: () => <ChatParameterization />,
                title: 'Definir parâmetros',
              },
              {
                content: () => <CalibrateNotes />,
                title: 'Calibrar notas',
              },
            ]}
          />
        </Content>
      </ContentWrapper>
    </Container>
  );
};
